export const dateFormatStr = 'YYYY-MM-DD';
export const dateMonthFormatStr = 'YYYY-MM'